import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {ArchieModule} from "./archie.module";

platformBrowserDynamic().bootstrapModule(ArchieModule);